export default __webpack_public_path__ + "static/media/117.857906e3.png";